import {
  ModalContainer
} from "./chunk-D55HY4ZG.mjs";
import {
  Button
} from "./chunk-6AHUTO4R.mjs";

// src/components/modal/confirmation-modal.tsx
import { Dialog } from "@headlessui/react";
import React, { useRef } from "react";
var ConfirmationModal = ({
  title,
  description,
  ctaButtonType = "primary",
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  onConfirm,
  confirmDisabled = false,
  ...props
}) => {
  const initialFocusRef = useRef(null);
  return /* @__PURE__ */ React.createElement(ModalContainer, { initialFocusRef, ...props }, /* @__PURE__ */ React.createElement("div", { className: "w-[calc(100vw-32px)] max-w-[500px] rounded bg-surface text-foreground" }, title && /* @__PURE__ */ React.createElement("header", { className: "border-b p-4" }, /* @__PURE__ */ React.createElement(Dialog.Title, { as: "h1", className: "my-label-md" }, title)), /* @__PURE__ */ React.createElement(Dialog.Description, { className: "p-4 my-body-md" }, description), /* @__PURE__ */ React.createElement("footer", { className: "-mx-2 flex p-4" }, /* @__PURE__ */ React.createElement("div", { className: "mx-2 flex-1" }, /* @__PURE__ */ React.createElement(Button, { variant: "secondary", onClick: props.onClose, fullWidth: true }, cancelLabel)), /* @__PURE__ */ React.createElement("div", { className: "mx-2 flex-1" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      ref: initialFocusRef,
      variant: ctaButtonType,
      onClick: onConfirm,
      fullWidth: true,
      disabled: confirmDisabled
    },
    confirmLabel
  )))));
};

export {
  ConfirmationModal
};
